import AppConfig, { WindowInletConfig } from '../types/app-config'

declare const WEBPACK_INLET_CONFIG: AppConfig
declare const WEBPACK_INLET_PORTAL_CONFIG_KEY: string

export function getConfig<TConfig extends AppConfig = AppConfig>() {
  const mapWindowConfig = (windowInletsConfig: WindowInletConfig): AppConfig => {
    const { webApi, azureApi, portals, ...restConfig } = windowInletsConfig
    const webApiKey = portals[WEBPACK_INLET_PORTAL_CONFIG_KEY]?.webApiKey
    if (!webApiKey) {
      throw new Error(`Missing api key portal ${WEBPACK_INLET_PORTAL_CONFIG_KEY} configuration`)
    }
    const baseConfig = {
      ...restConfig,
      webApi: {
        url: webApi.url,
        key: webApiKey
      }
    }

    return azureApi
      ? { ...baseConfig, azureApi: { url: azureApi.url, key: portals[WEBPACK_INLET_PORTAL_CONFIG_KEY]?.azureApiKey } }
      : baseConfig
  }

  return (WEBPACK_INLET_CONFIG ?? mapWindowConfig(window.inletsConfig as WindowInletConfig)) as unknown as TConfig
}
